import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.Toolbar.NudgeAction', {
    labelApprovers: '{count, plural, =1 {approver} other {approvers}}',
    labelReviewers: '{count, plural, =1 {reviewer} other {reviewers}}',
    helperText: `{count} {type} didn't make a decision {withExclude, select, true {(excluding yourself)} other {}}`,
    nudgedText: `We have nudged {count} {type}`,
    buttonNonNudged: `Nudge {type}`,
    buttonNudged: `{timer} till next ping action`,
});
